import { TYC_ACEPTADO } from '../../constants/perfiles'
import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Usuario`

export function buscarTodos() {
  return http.get(`${API_ENDPOINT}/BuscarTodos/`)
}

export function buscarPorId(idUsuario) {
  return http.get(`${API_ENDPOINT}/BuscarPorId/${idUsuario}`)
}

export function actualizar(usuarioDatoNuevo) {
  return http.put(API_ENDPOINT, usuarioDatoNuevo)
}

export function aceptarTerminos(idUsuario) {
  return actualizar({ idUsuario, aceptaTyC: TYC_ACEPTADO, soloAceptaTyC: true })
}

export function subirArchivo(archivo) {
  return http.post(`${API_ENDPOINT}/Upload`, archivo)
}

export function obtenerTiposFiscales() {
  return http.get(`${CONS.API_ENDPOINT_EBM}/TipoCondicionFiscal/BuscarTodos`)
}

export function obtenerProveedoresPropios(empid) {
  return http.get(`${API_ENDPOINT}/BuscarProveedoresPropios/${empid}`)
}

export function obtenerVendedoresCtaCte(empid) {
  return http.get(`${API_ENDPOINT}/BuscarUsuariosCtaCte/${empid}`)
}
